import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const OtherTutorialPlaylistModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=-yDYe5zRiLI&list=PLbZqv9nNJfpFps2UrI6yLMKXrqEyLvwar&index=1" />
);

export default OtherTutorialPlaylistModal;
